import { useCallback } from 'react';
import { ResponseError } from 'services/api/base';
import {
  useDeleteTrackingForecastPreferenceMutation,
} from 'services/api/Meteorology/Fields/TrackingForecast/DetailedView';
import { useHandleRequestErrors } from 'utils/hooks';

export default function useDeletePreference() {
  const [trigger, { isLoading, error }] = useDeleteTrackingForecastPreferenceMutation();
  const preferenceDeleteTrigger = useCallback((name: string) => () => {
    trigger({ name });
  }, [trigger]);

  useHandleRequestErrors(error as ResponseError | undefined);

  return {
    preferenceDeleteTrigger,
    isLoading,
  };
}
